import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule, NgModel } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { ListFilter } from '../../../../core/models/list-filter';
import { BehaviorSubject } from 'rxjs';

import { UserListService } from '../../../../core/services/user-list/user-list.service';
import { FoMaUserModel } from '../../models/foma-user.model';
import { FilterInputChipsComponent } from '../../../../core/components/filter-input-chips/filter-input-chips.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-user-list-filter',
  imports: [MatFormField, MatLabel, MatInput, MatInputModule, FormsModule, FilterInputChipsComponent, MatIconModule],
  templateUrl: './user-list-filter.component.html',
  styleUrl: './user-list-filter.component.scss'
})
export class UserListFilterComponent {
  filterValues!: ListFilter;

  private users: FoMaUserModel[] = [];
  searchTerm: string = '';

  constructor(private userListService: UserListService) {
    this.filterValues = {
      search: []
    };

    this.userListService.data$.subscribe(async userList => {
      this.users = userList ? userList : [];
      if (this.users) {
        this.initializeFilters();
      }
    });
  }

  ngAfterViewInit() {
    this.initializeFilters();
  }

  async initializeFilters() {
    this.searchTerm = this.filterValues.search.length === 1 ? this.filterValues.search[0].value : '';

    this.applyFilter();
  }

  applyFilter() {
    if (this.filterValues.search.length === 0) {
      this.searchTerm = '';
    }

    this.filterValues = { ...this.filterValues };
    this.userListService.applyFilter(this.filterValues);
  }

  filterSelectableValuesByQuery() {
    const hasSearchTerm = (this.searchTerm ?? '').trim().length > 0;

    if (!hasSearchTerm) {
      this.filterValues.search = [];
      this.applyFilter();
      return;
    }

    this.searchTerm = this.searchTerm.trim();

    if (!this.filterValues.search || this.filterValues.search.length === 0) {
      this.filterValues.search = [{ value: this.searchTerm, activated: true }];
    } else {
      this.filterValues.search[0].value = this.searchTerm;
      this.filterValues.search[0].activated = true;
    }

    this.applyFilter();
  }
}
